<wm-form-activity-input-view
  [activity]="activity"
  [form]="form"
  [isReadOnly]="true"
></wm-form-activity-input-view>

@if(!templateForPermitForm) {

<div class="card">
  <div class="card-body">
    <h6 class="card-title">Fee Summary</h6>

    <ng-container *ngIf="activity.model.fees">
      <ul class="list-unstyled mt-3">
        <li *ngFor="let fee of activity.model.fees" class="my-2">
          {{ fee.label }}
          <span class="float-right">{{ fee.formulaValue | currency }}</span>
        </li>
      </ul>

      <hr />
    </ng-container>

    <ng-container *ngIf="activity.model.fees">
      <ul class="list-unstyled mt-3">
        <li>
          Total Fees
          <span class="float-right">
            {{ activity.model.totalFees | currency }}
          </span>
        </li>
      </ul>

      <hr />
    </ng-container>

    <h6 class="mt-4">
      Total Due

      <span class="float-right font-weight-bold">
        {{ activity.model.totalDue | currency }}
      </span>
    </h6>
  </div>
</div>

<ng-container
  *ngIf="activity.model.payments && activity.model.payments.length > 0"
>
  <div class="card mt-4">
    <div class="card-body">
      <h6 class="card-title">
        Payments Made
      </h6>
      <table class="table">
        <thead>
          <tr>
            <th>Payment Method</th>
            <th>Paid On</th>
            <th>Confirmation Number</th>
            <th style="text-align: right">Amount</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pmt of activity.model.payments">
            <td>{{ pmt.paymentMethod }}</td>
            <td>{{ pmt.confirmedOn | date: 'MMMM d, yyyy h:mm a' }}</td>
            <td>{{ pmt.confirmationData?.confirmationNumber }}</td>
            <td align="right">{{ pmt.requestedAmount | currency }}</td>
            <td>
              <a
                [href]="apiBase + '/files/receipt/' + pmt.id"
                class="btn btn-raised btn-primary float-right"
                target="_blank"
                rel="noopener"
              >
                View receipt
              </a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td align="right" colspan="4">
              <b>Total Paid:</b>&nbsp;&nbsp;
              {{ activity.model.totalPaid | currency }}
            </td>
            <td>
              <a
                [href]="
                  apiBase + '/files/activityReceipt/' + activity.activityDataId
                "
                class="btn btn-raised btn-primary float-right"
                target="_blank"
                rel="noopener"
                *ngIf="
                  activity.model.payments && activity.model.payments.length > 1
                "
              >
                Full Receipt
              </a>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</ng-container>
} @else{
<div class="card shadow-sm">
  <div class="card-body">
    <wm-common-text
      [data]="{ text: 'Fee Summary', fontWeight: 'bold', fontSize: 18 }"
      class="card-title d-block mb-3"
    >
    </wm-common-text>

    <ng-container *ngIf="activity.model.fees">
      <ul class="list-unstyled mt-3">
        <li
          *ngFor="let fee of lineItems"
          class="my-2 d-flex justify-content-between"
        >
          <wm-common-text [data]="{ text: fee.label }"></wm-common-text>
          <wm-common-text
            [data]="{ text: fee.formulaValue | currency }"
          ></wm-common-text>
        </li>
      </ul>
      <hr />
    </ng-container>

    <ng-container *ngIf="activity.model.fees">
      <div class="d-flex justify-content-between mt-3">
        <wm-common-text [data]="{ text: 'Total Fees' }"></wm-common-text>
        <wm-common-text
          [data]="{ text: activity.model.totalFees | currency }"
        ></wm-common-text>
      </div>
      <hr />
    </ng-container>

    <div class="d-flex justify-content-between mt-4">
      <wm-common-text
        [data]="{ text: 'Total Due', fontWeight: 'bold', fontSize: 16 }"
      ></wm-common-text>
      <wm-common-text
        [data]="{
          text: activity.model.totalDue | currency,
          fontWeight: 'bold',
          fontSize: 16
        }"
      >
      </wm-common-text>
    </div>
  </div>
</div>

<ng-container
  *ngIf="activity.model.payments && activity.model.payments.length > 0"
>
  <div
    class="card mt-4"
    *ngIf="activity.model.payments && activity.model.payments.length > 0"
  >
    <div class="card-body">
      <h6 class="card-title">Payments Made</h6>

      <wm-common-table
        [columns]="paymentTableColumns"
        [data]="data"
        tableClass="table"
      >
      </wm-common-table>

      <div class="text-right mt-3">
        <wm-common-text
          [data]="{
            text: 'Total Paid: ' + (activity.model.totalPaid | currency),
            fontWeight: 'bold'
          }"
        >
        </wm-common-text>

        <div class="mt-2" *ngIf="activity.model.payments.length > 1">
          <a
            [href]="
              apiBase + '/files/activityReceipt/' + activity.activityDataId
            "
            class="btn btn-raised btn-primary"
            target="_blank"
          >
            Full Receipt
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>

}
